"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const reactstrap_1 = require("reactstrap");
const __1 = require("../../..");
const react_hanger_1 = require("react-hanger");
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("../../../utils");
exports.OsmosysListItem = (props) => {
    const { state } = react_hanger_1.useSetState({
        inferredHeight: 130,
        showCollapsedChildren: false,
    });
    const { isPlaceholder, linkURL, body, meta, faProps, icon, title, thumbnailURL, itemMargin, itemPadding, className, artClassName, iconLabel, } = props;
    const hasArtCol = !!(faProps || icon || thumbnailURL);
    const artComp = hasArtCol && (react_1.default.createElement(utils_1.OsmosysDiv, { className: artClassName, flexColCentered: true, padding: "x" },
        react_1.default.createElement(__1.OsmosysTooltip, { label: iconLabel, off: !iconLabel },
            react_1.default.createElement("figure", { className: "text-center mb-0", style: {
                    // width: '100%',
                    maxHeight: 200,
                    maxWidth: 200,
                } }, thumbnailURL ? (react_1.default.createElement("img", { src: thumbnailURL, style: { height: '100%', objectFit: 'contain', width: '100%' } })) : faProps ? (react_1.default.createElement("h3", { className: "mb-0" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({}, faProps)))) : (icon)))));
    const topper = !isPlaceholder && (react_1.default.createElement(reactstrap_1.Row, { className: classnames_1.default('p-2') },
        artComp,
        react_1.default.createElement(reactstrap_1.Col, { className: "flex-col-centered" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_if_1.When, { condition: !!title },
                    react_1.default.createElement("h3", { className: "m-0" }, title)),
                react_1.default.createElement(react_if_1.When, { condition: !!meta },
                    react_1.default.createElement("div", { className: "m-0 lead" }, meta)),
                body)),
        react_1.default.createElement(react_if_1.When, { condition: !isPlaceholder && !!linkURL },
            react_1.default.createElement(reactstrap_1.Col, { className: "flex-col-centered flex-grow-0" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(__1.OsmosysButton, { color: "primary", osysStyle: "outline", className: "px-3", osysName: "OsmosysListItem.open", osysIcon: "arrowRight", iconPosition: "right", iconStyle: "solid" }, "Open"))))));
    return (react_1.default.createElement(reactstrap_1.Card, { "data-is-placeholder": isPlaceholder ? 'true' : 'false', className: classnames_1.default('toolbar-query-list-item shadow-sm rounded', itemMargin, itemPadding, {
            'my-2': !itemMargin,
            'p-2': !itemPadding,
        }, linkURL && 'text-dark', className), tag: linkURL ? react_router_dom_1.Link : undefined, to: linkURL || undefined, style: {
            minHeight: isPlaceholder ? state.inferredHeight : undefined,
        } },
        topper,
        react_1.default.createElement(react_if_1.When, { condition: !!isPlaceholder },
            react_1.default.createElement(__1.OsmosysPlaceholder, { flexColFilled: true }))));
};
//# sourceMappingURL=index.js.map